import { Component } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
@Component({
    selector   : 'app-bar-plus',
    templateUrl: './bar-plus.component.html',
    styleUrls  : ['./bar-plus.component.scss']
})
export class AppBarPlusStep4Component
{

    constructor(private appConfig: AppConfigService) {
        this.appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar   : 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer    : {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });
    }
}
